import {useEffect, useRef, useState} from 'react';
import {useReactToPrint} from "react-to-print";
import Swal from "sweetalert2";

export default function usePdf({tableRef, getAllList, setIsExport, updateList, filename}) {

  const [isPrinting, setIsPrinting] = useState(false);

  // 'onBeforeGetContent'에서 사용 중인 Resolve Promise를 저장합니다
  const promiseResolveRef = useRef(null);

  // 상태가 변경되고 Promise resolve가 사용될 수 있기를 기다립니다.
  useEffect(() => {
    if (isPrinting && promiseResolveRef.current) {
      // Promise를 해결하여 DOM 업데이트가 완료되었음을 'react-to-print'에게 알립니다.
      promiseResolveRef.current();
    }
  }, [isPrinting]);


  const generatePdf = useReactToPrint({
    content: () => tableRef.current,
    documentTitle: `${filename}.pdf`,
    onBeforeGetContent: () => {
      return new Promise((resolve) => {
        promiseResolveRef.current = resolve;

        Swal.fire({
          title: `PDF 다운로드 하시겠습니까?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: `확인`,
          cancelButtonText: '취소'
        })
            .then((result) => {
              if (result.isConfirmed) {
                console.log("PDF 다운로드를 시작합니다.");
                getAllList();
                setTimeout(() => setIsPrinting(true), 1000);
              } else if (result.isDismissed || result.isDenied) {
                console.log("PDF 다운로드를 취소합니다.");
              }
            })
            .catch((error) => {
              console.log(error);
            })
      });
    },
    onAfterPrint: () => {
      // Reset the Promise resolve so we can print again
      promiseResolveRef.current = null;
      setIsPrinting(false);

      setIsExport(false);
      updateList();
    }
  });

  return generatePdf;
};